import { Button } from '@/components/ui/button';
import { CallState } from '@/types/websocket-call-messages';

type CallActionButtonProps = {
  callState: CallState;
  isReadyToCall: boolean;
  onCall: () => void;
};

/**
 * This component renders the action button for placing a call.
 * It handles both the call state and the readiness of the system to place a call.
 */
export default function CallActionButton({
  callState,
  isReadyToCall,
  onCall,
}: CallActionButtonProps) {
  switch (callState) {
    case CallState.IDLE:
      return (
        <Button disabled={!isReadyToCall} onClick={onCall} variant="primary">
          {isReadyToCall ? 'Place Call' : 'Connecting...'}
        </Button>
      );
    case CallState.PLACING:
      return (
        <Button disabled variant="secondary">
          Placing call...
        </Button>
      );
    case CallState.RINGING:
      return (
        <Button disabled variant="secondary">
          Ringing...
        </Button>
      );
    case CallState.IN_PROGRESS:
    case CallState.ACCEPTED:
      return null;
    case CallState.REJECTED:
    case CallState.ENDED:
      return (
        <Button disabled={!isReadyToCall} onClick={onCall} variant="primary">
          Place Call
        </Button>
      );
    default:
      return null;
  }
}
